import type { CategoryTagsResponse } from '@contracts/order/OrderCategoriesTagsResponse';
import { OrderTab } from '@src/orders/domain/OrderTab';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useQuery } from '@tanstack/react-query';

interface Props {
  assignedToMe: boolean;
}

const UNLOADED_DATA: CategoryTagsResponse = {
  requiresAttention: false,
  totalCount: 0,
};

export const ORDER_CATEGORIES_QUERY_KEYS = ['OrdersClient.getCategorizedTags'];

export const useOrderTabs = ({ assignedToMe }: Props) => {
  const { data, isLoading } = useQuery({
    queryKey: [...ORDER_CATEGORIES_QUERY_KEYS, assignedToMe],
    queryFn: () => OrdersClient.getCategorizedTags({ assignedToMe }),
  });

  return {
    orderTabs: {
      [OrderTab.New]: data?.new ?? UNLOADED_DATA,
      [OrderTab.Active]: data?.active ?? UNLOADED_DATA,
      [OrderTab.Processed]: data?.processed ?? UNLOADED_DATA,
      [OrderTab.Archived]: UNLOADED_DATA,
    },
    isLoading,
  };
};
